import { useRef, useState, useEffect } from "react";
import Carousel, { consts } from "react-elastic-carousel";
import CircleButton from "./CircleButton";

import Button from "@components/Button";

import IconDonate from "assets/svgs/donate.svg";
import IconFolder from "assets/svgs/folder.svg";
import IconLearn from "assets/svgs/learn.svg";
import IconMap from "assets/svgs/map.svg";
import IconShare from "assets/svgs/share.svg";
import IconSound from "assets/svgs/sound.svg";
import IconSource from "assets/svgs/source.svg";
import IconTakeAction from "assets/svgs/take-action.svg";
import IconWatch from "assets/svgs/watch.svg";

// TODO: hopefully we remove the parens and this will need to be updated
const renderIcon = (type) => {
  switch (type) {
    case "Listen":
      return <IconSound width="26" />;
    case "Share":
      return <IconShare width="26" />;
    case "Explore":
      return <IconMap width="26" />;
    case "Misc":
      return <IconFolder width="26" />;
    case "Donate":
      return <IconDonate width="26" />;
    case "Watch":
      return <IconWatch width="26" />;
    case "Learn":
      return <IconLearn width="26" />;
    case "Take Action":
      return <IconTakeAction width="26" />;
    default:
      return <IconSource width="26" />;
  }
};

export default function HowYouCanHelp({ uncovereds }) {
  const [nextEnabled, setNextEnabled] = useState(true);
  const [prevEnabled, setPrevEnabled] = useState(true);
  const carouselRef = useRef();

  // Handles arrow enabling/disabling on resize and slide
  const setCarouselArrows = (future = false) => {
    const adjust = future ? 1 : 0;
    const activeIndex = carouselRef.current.state.activeIndex;
    const canSlidePrev =
      activeIndex !==
      carouselRef.current.getNextItemIndex(activeIndex - adjust, true);
    const canSlideNext =
      activeIndex !==
      carouselRef.current.getNextItemIndex(activeIndex + adjust, false);
    setNextEnabled(canSlideNext);
    setPrevEnabled(canSlidePrev);
  };

  // Sets the initial arrows
  useEffect(() => {
    const { children, itemsToShow } =
      carouselRef.current.getDerivedPropsFromBreakPoint();
    setNextEnabled(children.length > itemsToShow);
  }, []);

  const breakPoints = [
    { width: 1, itemsToShow: 1 },
    { width: 359, itemsToShow: 1 },
    { width: 500, itemsToShow: 2 },
    { width: 768, itemsToShow: 2 },
    { width: 1024, itemsToShow: 3 },
  ];

  const handleResize = () => {
    setCarouselArrows();
  };

  const handleSlideNext = () => {
    carouselRef.current.slideNext();
    setCarouselArrows(true);
  };

  const handleSlidePrevious = () => {
    carouselRef.current.slidePrev();
    setCarouselArrows(true);
  };

  const handleOnChange = () => {
    setCarouselArrows();
  };
  return (
    <section className="max-w-6xl	mx-auto px-4 pt-16 xl:px-0">
      <header className="relative sm:flex sm:justify-between">
        <h2 className="highlight mb-4">What&apos;s Left to be Uncovered</h2>
        <div className="flex justify-end">
          <CircleButton
            disabled={!prevEnabled}
            text="slide left"
            onClick={handleSlidePrevious}
          />
          <CircleButton
            disabled={!nextEnabled}
            className="ml-2.5"
            direction="right"
            text="slide right"
            onClick={handleSlideNext}
          />
        </div>
      </header>
      <Carousel
        outerSpacing={-8}
        itemPadding={[0, 1]}
        itemPosition={consts.START}
        ref={carouselRef}
        breakPoints={breakPoints}
        showArrows={false}
        pagination={false}
        className="flex sm:-mx-1.5"
        onResize={handleResize}
        onChange={handleOnChange}
        showEmptySlots
        preventDefaultTouchmoveEvent
      >
        {uncovereds.map((uncovered) => {
          const { description_text, media_type, summary_text, title, url } =
            uncovered;

          return (
            <div className="flex flex-col" key={title+url}>
              {url ? (
                <a
                  className="bg-white flex block border flex-grow max-w-sm m-3 p-4 rounded w-full"
                  href={url}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <div>
                    <figure className="flex justify-between">
                      {media_type && (
                        <div className="bg-red-100 flex flex-shrink-0 h-14 items-center justify-center mr-4 rounded-full text-red-900 w-14">
                          {renderIcon(media_type)}
                        </div>
                      )}
                      <div className="flex flex-col flex-grow items-start justify-between">
                        <figcaption className="text-sm">
                          {media_type && (
                            <small className="block text-yellow-400 text-xs">
                              {media_type}
                            </small>
                          )}
                          {title && (
                            <strong className="block font-semibold my-2">
                              {title}
                            </strong>
                          )}
                          {description_text && (
                            <p className="mb-2 text-xs text-gray-400">
                              {description_text}
                            </p>
                          )}
                        </figcaption>
                        {summary_text && (
                          <Button
                            className="mt-3"
                            emphasis="secondary"
                            height="28"
                          >
                            {summary_text}
                          </Button>
                        )}
                      </div>
                    </figure>
                  </div>
                </a>
              ) : (
                <div className="bg-white flex flex-grow block border max-w-sm m-3 p-4 rounded w-full">
                  <figure className="flex justify-between">
                    {media_type && (
                      <div className="bg-red-100 flex flex-shrink-0 h-14 items-center justify-center mr-4 rounded-full text-red-900 w-14">
                        {renderIcon(media_type)}
                      </div>
                    )}
                    <div className="flex flex-col flex-grow items-start justify-between">
                      <figcaption className="text-sm">
                        {media_type && (
                          <small className="block text-yellow-400 text-xs">
                            {media_type}
                          </small>
                        )}
                        {title && (
                          <strong className="block font-semibold my-2">
                            {title}
                          </strong>
                        )}
                        {description_text && (
                          <p className="mb-2 text-xs text-gray-400">
                            {description_text}
                          </p>
                        )}
                      </figcaption>
                      {summary_text && (
                        <Button
                          className="mt-3"
                          emphasis="secondary"
                          height="28"
                        >
                          {summary_text}
                        </Button>
                      )}
                    </div>
                  </figure>
                </div>
              )}
            </div>
          );
        })}
      </Carousel>
    </section>
  );
}
